// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.musicCards {
    background-color: black;
    width: auto;
    display: flex;
    /* flex-direction: row; */
    flex-wrap: wrap;
    /* justify-content: center; */
    gap: 10px;
    padding: 10px;
    /* margin: auto; */
}

.music_card {
    width: 15rem;
    height: 20rem;
    color: #fff;
    background: #00040f;
    overflow: hidden;
    border-radius: 0.3rem;
    cursor: pointer;
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    transition: ease-in 0.10s;
    padding: 1rem;
}

.music_card:hover {
    background-color: #1a1e2b;
    box-shadow: 5px 20px 100px 25px #1111;
}

.music_card_img {
    width: 100%;
    height: 12rem;
    box-shadow: 5px 20px 140px 25px #5a5a7a;
}

.card_img {
    width: 100%;
    height: 100%;
    border-radius: 0.3rem;
    object-fit: cover;
    background-color: #1111;
}

.music_title {
    text-wrap: balance;
    line-height: 1;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.music_title h2 {
    font-size: 1.3rem;
    font-weight: 500;
}

.music_title p {
    font-size: 1rem;
    font-weight: 400;
    color: #fff;
}

.play-icon {
    position: absolute;
    top: 46%;
    right: 9%;
}

.circle {
    width: 3rem;
    height: 3rem;
    background-color: rgb(50, 233, 50);
    border-radius: 50%;
    transform: scale(0.95);
    display: grid;
    place-items: center;
}

.triangle {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 18px solid black;
    transform: rotate(90deg);
    margin-left: 0.2rem;
}

.play-icon .circle {
    transform: scale(1);
    cursor: auto;
}

.Edit_icons {
    position: absolute;
    top: 70%;
    right: 2%;
    color: white;
}

.Heart_icons {
    position: absolute;
    top: 50%;
    right: 70%;
    color: white;
}

.Del_icons {
    position: absolute;
    top: 80%;
    right: 2%;
    color: white;
}

@media (max-width: 768px) {
    .music_work {
        align-items: center;
        justify-content: center;
    }
}

/* /////////////////////////Music player card////////////////////////// */
.music_player {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 9999;
}

.music-player {
    --primary-color: #ddd;
    --secondary-color: #999;
    --green-color: #2d5;
    --padding: 1em;
    background-color: #111;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 7rem;
    padding: var(--padding);
    color: var(--primary-color);
}

i {
    color: var(--secondary-color);
}

i:hover {
    color: var(--primary-color);
}

.song-bar {
    position: absolute;
    left: var(--padding);

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1.5rem;
    width: 25%;
}

.song-infos {
    display: flex;
    align-items: center;
    gap: 1em;
}

.image-container {
    --size: 4.5em;
    flex-shrink: 0;
    width: var(--size);
    height: var(--size);
    /* background-color: gray; */
}

.image-container img {
    width: 100%;
    height: 100%;
    object-fit: fill;
}

.song-description p {
    margin: 0.2em;
}

.title,
.artist {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.title:hover,
.artist:hover {
    text-decoration: underline;
}

.artist {
    color: var(--secondary-color);
}

.icons {
    display: flex;
    gap: 1em;
}

.progress-controller {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 1.5em;
    color: var(--secondary-color);
}

.control-buttons {
    display: flex;
    align-items: center;
    gap: 2em;
}

.play-pause {
    display: inline-block;
    padding: 1em;
    background-color: var(--primary-color);
    color: #111;
    border-radius: 50%;
}

.play-pause:hover {
    transform: scale(1.1);
    color: #111;
}

.progress-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
}

.progress-bar {
    height: 4px;
    border-radius: 10px;
    width: 30%;
    background-color: #ccc4;
}

.progress {
    position: relative;
    height: 100%;
    width: 30%;
    border-radius: 10px;
    background-color: var(--secondary-color);
}

.progress-bar:hover .progress {
    background-color: var(--green-color);
}

.progress-bar:hover .progress::after {
    content: "";
    position: absolute;
    --size: 1em;
    width: var(--size);
    height: var(--size);
    right: 0;
    border-radius: 50%;
    background-color: var(--primary-color);
    transform: translate(50%, calc(2px - 50%));
}

.other-features {
    position: absolute;
    right: var(--padding);
    display: flex;
    flex-direction: row;
    gap: 1em;
}

.volume-bar {
    display: flex;
    align-items: center;
    gap: .7em;
}

.volume-bar .progress-bar {
    width: 6em;
}

.volume-bar .progress-bar:hover .progress::after {
    --size: .8em;
}

@media (max-width: 600px) {
    .song-description {
        display: none;
    }

    .image-container {
        --size: 4em;
        flex-shrink: 0;
        width: var(--size);
        height: var(--size);
    }

    .image-container img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.skeleton {
    background: linear-gradient(to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.5) 50%,
            rgba(255, 255, 255, 0) 80%),
        lightgray;
    background-repeat: repeat-y;
    background-size: 50px 500px;
    background-position: 0 0;
    animation: shine 1s infinite;
}

@keyframes shine {
    to {
        background-position: 100% 0;
    }
}

.p_sket {
    width: 10rem;
    height: 1rem;
    margin: 1rem;
}

.btn_skel {
    width: 20rem;
    height: 2rem;
}

.play_skel {
    width: 28rem;
    height: 1.8rem;
}

@media (max-width:600px) {

    .btn_skel {
        width: 12rem;
        height: 1.5rem;
    }

    .play_skel {
        width: 12rem;
        height: 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Component new/userWork/MusicWorkCard/MusicWorkCard.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wIAAwI;AAC5I;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,+BAA+B;IAC/B,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA;IACI;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ;;AAEA,yEAAyE;AACzE;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;;IAEpB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,sCAAsC;IACtC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,sCAAsC;IACtC,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;;;;iBAIa;IACb,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;AACJ","sourcesContent":[".musicCards {\r\n    background-color: black;\r\n    width: auto;\r\n    display: flex;\r\n    /* flex-direction: row; */\r\n    flex-wrap: wrap;\r\n    /* justify-content: center; */\r\n    gap: 10px;\r\n    padding: 10px;\r\n    /* margin: auto; */\r\n}\r\n\r\n.music_card {\r\n    width: 15rem;\r\n    height: 20rem;\r\n    color: #fff;\r\n    background: #00040f;\r\n    overflow: hidden;\r\n    border-radius: 0.3rem;\r\n    cursor: pointer;\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    position: relative;\r\n    transition: ease-in 0.10s;\r\n    padding: 1rem;\r\n}\r\n\r\n.music_card:hover {\r\n    background-color: #1a1e2b;\r\n    box-shadow: 5px 20px 100px 25px #1111;\r\n}\r\n\r\n.music_card_img {\r\n    width: 100%;\r\n    height: 12rem;\r\n    box-shadow: 5px 20px 140px 25px #5a5a7a;\r\n}\r\n\r\n.card_img {\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 0.3rem;\r\n    object-fit: cover;\r\n    background-color: #1111;\r\n}\r\n\r\n.music_title {\r\n    text-wrap: balance;\r\n    line-height: 1;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n}\r\n\r\n.music_title h2 {\r\n    font-size: 1.3rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.music_title p {\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    color: #fff;\r\n}\r\n\r\n.play-icon {\r\n    position: absolute;\r\n    top: 46%;\r\n    right: 9%;\r\n}\r\n\r\n.circle {\r\n    width: 3rem;\r\n    height: 3rem;\r\n    background-color: rgb(50, 233, 50);\r\n    border-radius: 50%;\r\n    transform: scale(0.95);\r\n    display: grid;\r\n    place-items: center;\r\n}\r\n\r\n.triangle {\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 10px solid transparent;\r\n    border-right: 10px solid transparent;\r\n    border-bottom: 18px solid black;\r\n    transform: rotate(90deg);\r\n    margin-left: 0.2rem;\r\n}\r\n\r\n.play-icon .circle {\r\n    transform: scale(1);\r\n    cursor: auto;\r\n}\r\n\r\n.Edit_icons {\r\n    position: absolute;\r\n    top: 70%;\r\n    right: 2%;\r\n    color: white;\r\n}\r\n\r\n.Heart_icons {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 70%;\r\n    color: white;\r\n}\r\n\r\n.Del_icons {\r\n    position: absolute;\r\n    top: 80%;\r\n    right: 2%;\r\n    color: white;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .music_work {\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n/* /////////////////////////Music player card////////////////////////// */\r\n.music_player {\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n.music-player {\r\n    --primary-color: #ddd;\r\n    --secondary-color: #999;\r\n    --green-color: #2d5;\r\n    --padding: 1em;\r\n    background-color: #111;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: relative;\r\n    height: 7rem;\r\n    padding: var(--padding);\r\n    color: var(--primary-color);\r\n}\r\n\r\ni {\r\n    color: var(--secondary-color);\r\n}\r\n\r\ni:hover {\r\n    color: var(--primary-color);\r\n}\r\n\r\n.song-bar {\r\n    position: absolute;\r\n    left: var(--padding);\r\n\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 1.5rem;\r\n    width: 25%;\r\n}\r\n\r\n.song-infos {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1em;\r\n}\r\n\r\n.image-container {\r\n    --size: 4.5em;\r\n    flex-shrink: 0;\r\n    width: var(--size);\r\n    height: var(--size);\r\n    /* background-color: gray; */\r\n}\r\n\r\n.image-container img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: fill;\r\n}\r\n\r\n.song-description p {\r\n    margin: 0.2em;\r\n}\r\n\r\n.title,\r\n.artist {\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 1;\r\n    overflow: hidden;\r\n}\r\n\r\n.title:hover,\r\n.artist:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.artist {\r\n    color: var(--secondary-color);\r\n}\r\n\r\n.icons {\r\n    display: flex;\r\n    gap: 1em;\r\n}\r\n\r\n.progress-controller {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 1.5em;\r\n    color: var(--secondary-color);\r\n}\r\n\r\n.control-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 2em;\r\n}\r\n\r\n.play-pause {\r\n    display: inline-block;\r\n    padding: 1em;\r\n    background-color: var(--primary-color);\r\n    color: #111;\r\n    border-radius: 50%;\r\n}\r\n\r\n.play-pause:hover {\r\n    transform: scale(1.1);\r\n    color: #111;\r\n}\r\n\r\n.progress-container {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 1em;\r\n}\r\n\r\n.progress-bar {\r\n    height: 4px;\r\n    border-radius: 10px;\r\n    width: 30%;\r\n    background-color: #ccc4;\r\n}\r\n\r\n.progress {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 30%;\r\n    border-radius: 10px;\r\n    background-color: var(--secondary-color);\r\n}\r\n\r\n.progress-bar:hover .progress {\r\n    background-color: var(--green-color);\r\n}\r\n\r\n.progress-bar:hover .progress::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    --size: 1em;\r\n    width: var(--size);\r\n    height: var(--size);\r\n    right: 0;\r\n    border-radius: 50%;\r\n    background-color: var(--primary-color);\r\n    transform: translate(50%, calc(2px - 50%));\r\n}\r\n\r\n.other-features {\r\n    position: absolute;\r\n    right: var(--padding);\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 1em;\r\n}\r\n\r\n.volume-bar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: .7em;\r\n}\r\n\r\n.volume-bar .progress-bar {\r\n    width: 6em;\r\n}\r\n\r\n.volume-bar .progress-bar:hover .progress::after {\r\n    --size: .8em;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .song-description {\r\n        display: none;\r\n    }\r\n\r\n    .image-container {\r\n        --size: 4em;\r\n        flex-shrink: 0;\r\n        width: var(--size);\r\n        height: var(--size);\r\n    }\r\n\r\n    .image-container img {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n    }\r\n}\r\n\r\n.skeleton {\r\n    background: linear-gradient(to right,\r\n            rgba(255, 255, 255, 0),\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(255, 255, 255, 0) 80%),\r\n        lightgray;\r\n    background-repeat: repeat-y;\r\n    background-size: 50px 500px;\r\n    background-position: 0 0;\r\n    animation: shine 1s infinite;\r\n}\r\n\r\n@keyframes shine {\r\n    to {\r\n        background-position: 100% 0;\r\n    }\r\n}\r\n\r\n.p_sket {\r\n    width: 10rem;\r\n    height: 1rem;\r\n    margin: 1rem;\r\n}\r\n\r\n.btn_skel {\r\n    width: 20rem;\r\n    height: 2rem;\r\n}\r\n\r\n.play_skel {\r\n    width: 28rem;\r\n    height: 1.8rem;\r\n}\r\n\r\n@media (max-width:600px) {\r\n\r\n    .btn_skel {\r\n        width: 12rem;\r\n        height: 1.5rem;\r\n    }\r\n\r\n    .play_skel {\r\n        width: 12rem;\r\n        height: 1.5rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
